import React from 'react';
type WaveDividerProps = {
  /** Color the wave fills with — should match the section BELOW the divider */
  fill: string;
  /** Flip vertically so the wave curves the other way */
  flip?: boolean;
  className?: string;
};

/**
 * Decorative section divider drawn as a soft wave.
 * Purely presentational, hidden from assistive tech.
 */
export function WaveDivider({
  fill,
  flip = false,
  className = ''
}: WaveDividerProps) {
  return <div className={`w-full overflow-hidden leading-[0] ${className}`} aria-hidden="true" data-id="element-161" data-mp="25h6ard7icqy">
      <svg viewBox="0 0 1440 90" preserveAspectRatio="none" className={`block w-full h-[48px] sm:h-[70px] md:h-[90px] ${flip ? 'rotate-180' : ''}`} data-id="element-162" data-mp="3tcl734ird2qx">
        <path d="M0,40 C240,90 480,0 720,32 C960,64 1200,96 1440,44 L1440,90 L0,90 Z" fill={fill} data-id="element-163" data-mp="6ytghwh52h06" />
      </svg>
    </div>;
}